import { LogService } from '@absg/angular-common';
import { AssignedProductDetail } from '@absg/api-formulary';
import { EventDetailInfo, EventInfo, ManagePositionApi } from '@absg/api-inventory';
import { NimAlertService } from '@absg/nim-client-shared';
import { Injectable } from '@angular/core';
import { StationInfoService } from 'core.services/station-info.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InventoryEventBuilderService {
  constructor(
    private stationInfoService: StationInfoService,
    private managePositionService: ManagePositionApi,
    private alertService: NimAlertService,
    private loggingService: LogService,
  ) { }

  createInventoryEventAsync(autoReorderFlag: boolean, supplierProductInclusion: AssignedProductDetail,
    itemMaxAfter: number, itemMinAfter: number, qtyonHand: number, positionContainerId: number,
    transactionTypeId: number, transactionTypeName: string, inventoryItemId: number, isBinItem: boolean,
    isPreferred: boolean, autoReorderProductDetial: AssignedProductDetail): Observable<void> {
    const aDate: Date = new Date();
    const clinic = this.stationInfoService.practiceClinicDetail.getValue();
    const station = this.stationInfoService.station.getValue();
    const loggedInUserId = 0; // this.getLoginUserId();
    const spiIdForItemOrdered = autoReorderProductDetial?.supplierProductInclusionId;
    const eventInfo: EventInfo = {
      clinicName: clinic.clinicName,
      clinicPartyId: clinic.clinicId,
      createdById: Number(loggedInUserId),
      fromStationContainerId: station.id,
      fromStationName: station.name,
      facilityId: station.facilityId,
      practiceDomain: clinic.domain,
      practicePartyId: clinic.practiceId,
      practicePartyName: clinic.practiceName,
      itemDetails: this.getItemDetail(autoReorderFlag, supplierProductInclusion, itemMaxAfter,
        itemMinAfter, qtyonHand, positionContainerId, inventoryItemId, spiIdForItemOrdered,
        isBinItem, isPreferred),
      patientId: 0,
      purchaseOrderId: 0,
      serviceDate: aDate, // TODO will fix the API contract later
      toStationContainerId: 0,
      toStationName: '',
      transactionTypeId,
      transactionTypeName,
      targetSupplierPartyId: 1, // TODO: replace when expanding past OSC to other suppliers
    };

    return this.managePositionService.autoReorder(eventInfo)
      .pipe(take(1), map(() => { }));
  }

  createInventoryEvent(autoReorderFlag: boolean, supplierProductInclusion: AssignedProductDetail,
    itemMaxAfter: number, itemMinAfter: number, qtyonHand: number, positionContainerId: number,
    transactionTypeId: number, transactionTypeName: string, inventoryItemId: number, isBinItem: boolean,
    isPreferred: boolean, autoReorderProductDetial: AssignedProductDetail): void {
    this.createInventoryEventAsync(autoReorderFlag, supplierProductInclusion, itemMaxAfter, itemMinAfter, qtyonHand, positionContainerId,
      transactionTypeId, transactionTypeName, inventoryItemId, isBinItem, isPreferred, autoReorderProductDetial)
      .subscribe(() => { },
        (error: Error) => {
          this.alertService.showSaveErrorAlert();
          this.loggingService.logError(error);
        },
      );
  }

  private getItemDetail(autoReorderFlag: boolean, supplierProductInclusion: AssignedProductDetail,
    itemMaxAfter: number, itemMinAfter: number, qtyonHand: number, positionContainerId: number,
    inventoryItemId: number, spiIdForItemOrdered: number, isBinItem: boolean, isPreferred: boolean,
  ): EventDetailInfo[] {
    // todo: why is this a very close copy of both
    // new-item-assignment.component - getItemDetail
    // assignment-item.component - getItemDetail
    const aDate: Date = new Date();
    const eventDetails: EventDetailInfo[] = [];
    const eventDetail: EventDetailInfo = {
      annexTransferQtyOnHandAfter: 0,
      annexTransferQtyOnHandBefore: 0,
      autoReorderEnabled: autoReorderFlag,
      dispenseConversionFactor: (supplierProductInclusion !== null) ? supplierProductInclusion.dFactor : 0,
      inventoryConversionFactor: (supplierProductInclusion !== null) ? supplierProductInclusion.iFactor : 0,
      itemMaxAfter,
      itemMaxBefore: 0,
      itemMinBefore: 0,
      itemMinAfter,
      pendingQtyOnHandBefore: 0,
      positionContainerId,
      productDescription: (supplierProductInclusion !== null) ? supplierProductInclusion.tradeName : '',
      purchaseConversionFactor: (supplierProductInclusion !== null) ? supplierProductInclusion.pFactor : 0,
      qtyOnHandAfter: qtyonHand,
      qtyOnHandBefore: 0,
      supplierProductInclusionId: (supplierProductInclusion !== null) ? supplierProductInclusion.supplierProductInclusionId : 0,
      supplierProductItemId: (supplierProductInclusion !== null) ? supplierProductInclusion.itemId : '',
      attendingPhysicianId: 0,
      detailNotes: '',
      diagnosisCode: '',
      inventoryItemId,
      labelNotes: '',
      lotExpirationDate: aDate,
      lotNumber: '',
      orderitemId: 0,
      packingSlipDetailId: 0,
      reqQtyInDispenseUnits: 0,
      reqQtyInDispenseUnitsFromCabinet: 0,
      reqQtyInDispenseUnitsFromUnderHood: 0,
      requiredNotesValue: '',
      reqWasteQtyInDispenseUnits: 0,
      retailPrice: 0,
      returnNotes: '',
      returnReasonListInclusionId: 0,
      serialNumber: '',
      wasteNotes: '',
      wasteReasonListInclusionId: 0,
      wholeSalePrice: 0,
      totalInCabinetAndUnderHoodQtyAfter: qtyonHand,
      spiIdForItemOrdered,
      isBin: isBinItem,
      isPreferredNDC: isPreferred,
    };
    eventDetails.push(eventDetail);
    return eventDetails;
  }
}
